import { DEFAULT_TYPE } from '@/page/store/defaultState'

/**
 * @typedef {(
 * 'yf_home'|
 * 'rja_home'|
 * 'job_search'|
 * 'job_search_with_detail'|
 * 'job_detail'|
 * 'job_landing_with_seo'|
 * 'job_landing'|
 * 'job_preview'|
 * 'job_theme_bare'|
 * 'job_theme_detached'|
 * 'job_theme_full'|
 * 'job_theme_neutral'|
 * 'job_theme_reference'|
 * 'company_search'|
 * 'company_search_with_detail'|
 * 'company_detail'|
 * 'company_detail_bare'|
 * 'company_landing'|
 * 'company_lp'|
 * 'job_lp'|
 * 'job_lp_catalog',
 * 'job_combination_lp_catalog',
 * 'yf_jobmail_unsubscribe',
 * 'jobmail_activate_error',
 * )} PageType
 */

/**
 * @typedef {Object} PageInitialState
 * @property {PageType} type
 */

/**
 * @return {PageInitialState}
 */
export default (
  {
    page: {
      type = DEFAULT_TYPE
    } = {}
  } = {}
) => ({
  type
})
